
import { useState } from 'react';
import { ReplyTemplateIcon } from '@/shared/config';
import { Button, Dialog, DialogContent } from '@/shared/ui';
import { TemplatePanel, type TemplateContext } from './TemplatePanel';
import styles from './TemplatePicker.module.css';

interface TemplatePickerProps {
  context: TemplateContext;
  value: string;
  onInsert: (next: string) => void;
}

export const TemplatePicker: React.FC<TemplatePickerProps> = ({ context, value, onInsert }) => {
  const [open, setOpen] = useState(false);

  const handleInsert = (text: string) => {
    onInsert(value.trim() ? `${value}\n${text}` : text);
  };

  return (
    <>
      <Button
        type="button"
        variant="ghost"
        size="sm"
        className={styles.trigger}
        onClick={() => setOpen(true)}
      >
        <ReplyTemplateIcon size={14} aria-hidden />
        Шаблоны
      </Button>
      <Dialog open={open} onOpenChange={setOpen}>
        { }
        <DialogContent className={styles.dialog} flush aria-label="Шаблоны ответов">
          <TemplatePanel
            context={context}
            variant="dialog"
            insertOnly
            onClose={() => setOpen(false)}
            onInsert={handleInsert}
          />
        </DialogContent>
      </Dialog>
    </>
  );
};
